import { render, staticRenderFns } from "./ScheduleAbsenceWarning.vue?vue&type=template&id=60bf52af&"
import script from "./ScheduleAbsenceWarning.vue?vue&type=script&lang=js&"
export * from "./ScheduleAbsenceWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports